module.exports = __webpack_public_path__ + "images/Tintri-f7e080.png";